import React from 'react';

//Import validators
import {
    emailValidator,
    requiredValidator,
    passwordValidator
} from 'modules/form/validators';

import './CustomInput.css';

export default class CustomInput extends React.Component {
    constructor(props) {
        super(props);

        this.value = this.props.defaultValue || '';
        console.log('################: CONSTRUCTING ');

        this.registerField();
    }

    registerField() {
        const validators = [];
        const typeValidators = this.getTypeValidators(this.props.type);

        if (typeValidators) validators.push(...typeValidators);

        if (this.props.required) {
            validators.push(requiredValidator);
        }
        this.props.form.registerField(this.props.name, validators, this.value);
    }

    getTypeValidators(type) {
        switch (type) {
            case 'email':
                return [emailValidator];
            case 'password':
                return [passwordValidator];
        }
    }

    render() {
        const name = this.props.name;
        // this.value = this.props.value;
        //let value = this.props.defaultValue;
        let value = '';

        if (this.props.form.state.fields[name]) {
            value = this.props.form.state.fields[name].value;
            console.log(
                'Field Value' +
                    this.props.form.state.fields[name].value +
                    'Space'
            );
        }

        //determin if there are any errors to display and if to apply error class
        let errorClass = '';
        let errorMessage = '';
        if (
            this.props.form.state.fields[this.props.name] &&
            this.props.form.state.fields[this.props.name].errors &&
            this.props.form.state.fields[this.props.name].errors.length > 0
        ) {
            errorClass = 'error';
            errorMessage = this.props.form.state.fields[this.props.name]
                .errors[0];
        }

        const classes = 'custom-input ' + errorClass;

        //TODO: Handle displaying multple errors
        return (
            <div className={classes}>
                <label for={this.props.name}>{this.props.label}</label>
                <input
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    type={this.props.type}
                    value={value}
                    onChange={this.props.form.handleOnChange}
                />
                <span className="inline-error">{errorMessage}</span>
            </div>
        );
    }
}
// {/* onBlur={this.onBlurHandler.bind(this)} */}



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-input/CustomInput.jsx